import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Imputacion`
//

export async function imputacion(empid, usrProv, idioma, jwt) {
  return await http.post(
    `${API_ENDPOINT}/ObtenerDatos`,
    {
      empid,
      usrProv,
      idioma
    },
    {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    }
  )
}
